import { defineComponent } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  name: "swiper",
  props: {
    swiperList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var store = useStore();
    /* 点击最新音乐添加背景色 */

    var swiperPlayerClick = function swiperPlayerClick(id, type) {
      //播放音乐
      if (type == 1) {
        store.dispatch("player/setCurrentSong", id);
      }
    };

    return {
      swiperPlayerClick: swiperPlayerClick
    };
  },
  components: {}
});